import React from "react";
import "./caro1.css";
import HeroImg from "../../../../assets/images/heroimg.jpg";
import HeroImg1 from "../../../../assets/images/heroimg1.jpg";
import HeroImg2 from "../../../../assets/images/heroimg2.jpg";
import Carousel from "react-bootstrap/Carousel";
import { useNavigate } from "react-router-dom";


const Caro1 = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="container-fluid hero-bg">
        <div className="container hero-content-wrapper">
          <div className="row">
            <div className="col-md-6">
              <div className="hero-content">
                <p className="hero-cont1">
                  We provide professional IT services
                </p>
                <p className="hero-cont2">
                  Delivering tech <br />
                  solutions for
                  <br /> your startups
                </p>
                <button onClick={() => navigate('/about')}>Read More</button>

              </div>
            </div>
            <div className="col-md-6">
              <div className="hero-image">
                <Carousel fade controls={false} indicators={false}>
                  <Carousel.Item>
                  <img src={HeroImg} alt="heroimg" className="heroimg1" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={HeroImg1} alt="heroimg" className="heroimg2" />
                  </Carousel.Item>
                  <Carousel.Item>
                  <img src={HeroImg2} alt="heroimg" className="heroimg3" />
                  </Carousel.Item>
                </Carousel>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Caro1;
